import { Box, Button, Container, Typography } from '@mui/material';
import { ArrowLeftIcon, HomeIcon } from 'lucide-react';
import { useNavigate } from 'react-router';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth='sm'
      sx={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: 8,
      }}
    >
      <Typography
        variant='h1'
        sx={{
          fontWeight: 800,
          fontSize: { xs: '6rem', sm: '8rem' },
          lineHeight: 1,
          color: 'primary.main',
          letterSpacing: '-0.05em',
        }}
      >
        404
      </Typography>

      <Box
        sx={{
          width: 64,
          height: 4,
          borderRadius: 2,
          bgcolor: 'accentYellow.main',
          my: 3,
        }}
      />

      <Typography variant='h5' sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
        Page Not Found
      </Typography>
      <Typography variant='body1' sx={{ color: 'text.secondary', mb: 4, maxWidth: 400 }}>
        The page you&apos;re looking for doesn&apos;t exist or may have been moved.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant='outlined' color='primary' startIcon={<ArrowLeftIcon size={18} />} onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          startIcon={<HomeIcon size={18} />}
          onClick={() => navigate('/')}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Container>
  );
}

export default NotFound;
